<template>
  <div class="iframe">
    <iframe id="iframe" src="http://xiaodian.qilacps.com/personal.html" />
  </div>
</template>

<script>
export default {
  name: 'index',
  mounted() {
    const el = document.getElementById("iframe").contentWindow.document.getElementsByClassName("baseInfo")[0]
    console.log(el)
  }
}
</script>

<style scoped>
.iframe {
  width: 100%;
  height: 100%;
  position: relative;
}

iframe {
  width: 100%;
  height: 100%;
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/view/link/index.vue